import React from 'react';
import { useHistory } from 'react-router-dom';
import { HeaderProps } from './Header.types';
import { getAppEnv } from '../../../../../config/env';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const Header = (props: HeaderProps) => {
  const { title } = props;

  const history = useHistory();

  const handleBackClick = () => {
    history.goBack();
  };

  return (
    <div className="LTSPageCommon-Header-wrapper">
      <div className="LTSPageCommon-Header-back-arrow" onClick={handleBackClick}>
        <img src={`${PUBLIC_URL}/static/public/ic_back_arrow.webp`} alt="back arrow in black color" />
      </div>
      <h1 className="LTSPageCommon-Header-title">{title}</h1>
    </div>
  );
};

export default Header;
